module.exports = __webpack_public_path__ + "static/media/cert5.624a1a43.png";